export default "__VITE_ASSET__H8UAST1j__"